export default __webpack_public_path__ + "static/media/spending-limits-icon.43dfb5b4.svg";